import { flowHomeEN } from './flow/home'
import { flowAcademicReportEN } from './flow/academicReport'
import { flowActiveEN } from './flow/active'
import { flowAdmissionTicketEN } from './flow/admissionTicket'
import { flowCertificateEN } from './flow/certificate'
import { flowComplainEN } from './flow/complain'
import { flowConsultEN } from './flow/consult'
import { flowCouponEN } from './flow/coupon'
import { flowDiscoverEN } from './flow/discover'
import { flowFollowUsEN } from './flow/followUs'
import { flowGradeReportEN } from './flow/gradeReport'
import { flowGroupEN } from './flow/group'
import { flowLoginEN } from './flow/login'
import { flowMessageEN } from './flow/message'
import { flowOrderEN } from './flow/order'
import { flowPayTheFeesEN } from './flow/payTheFees'
import { flowPersonalDataEN } from './flow/personalData'
import { flowReviewEN } from './flow/review'
import { flowSignUpEN } from './flow/signUp'
import { flowTaskEN } from './flow/task'
import { flowTeamUpEN } from './flow/teamUp'
import { flowImageEN } from './flow/image'
const message = {
  msg: 'Messages',
  msgcenter: 'Messages Center',
  home: {
    tabs: {
      txt1: 'Projects and Activities',
      txt2: 'Course Center',
      txt3: 'Highlights',
      txt4: 'Highlights'
    },
    logs: {
      txt1: 'Coming soon'
    },
    footTabs: {
      txt1: 'Home',
      txt2: 'Plaza',
      txt3: 'My Activites',
      txt4: 'My Page'
    },
    capsule: {
      txt1: 'Registered Activities',
      txt2: 'Task Progress',
      txt3: 'Start'
    },
    hotActivities: {
      txt1: 'Hot Topic',
      txt2: 'Those Development Plan on Track!'
    },
    activeItem: {
      txt1: 'Progresses'
    },
    recommendList: {
      txt1: 'Activities Recommended',
      txt2: 'The choice of tens of thousands of Junior and high school students！',
      txt3: 'Show All'
    },
    atlasList: {
      txt1: 'Highlights Recommended',
      txt2: 'Highlights of Activities',
      txt3: 'Show All'
    },
    palaza: {
      txt1: 'Event Plaza',
      txt2: 'Hey，learn together，play together',
      txt3: 'Enter the Plaza'
    },
    howToJoin: {
      txt1: ' How to Apply？',
      txt2: '4 Steps to Unlock Your Potential'
    },
    howToLearn: {
      txt1: 'Start Project-Based Learning from here',
      txt2: 'Team cooperation，Strive for perfection'
    }
  },
  userCenter: {
    panel: {
      txt1: 'MyActivies',
      txt2: 'My Coupons',
      txt3: 'Account Management',
      txt4: 'Contact Us',
      txt5: 'About Us',
      txt6: 'Log Out',
      txt7: 'Are you sure you want to log out?',
      txt8: 'My Order',
      txt9: 'Language Switch',
      txt10: 'Messages'
    },
    acountManage: {
      txt1: 'Account Management',
      txt2: 'Log In',
      txt3: 'Phone Number',
      txt4: 'E-mail Address',
      txt5: 'Change Password',
      oldPassword: 'Please enter your old password',
      newPassword: 'Please enter a new password',
      rePassword: 'Re-enter new password',
      graphicverificationCode: 'Graphical CAPTCHA',
      phonepl: 'Please enter your phone number',
      emailpl: 'Please enter your email address',
      verificationCode: 'Graphical CAPTCHA',
      cancel: 'cancel',
      comfirm: 'comfirm'
    },
    changeNickname: {
      txt1: 'Cancel',
      txt2: 'Change Nickname',
      txt3: 'Finish',
      txt4: 'Enter Nickname',
      txt5: 'Amendments to the success of information! '
    },
    loginPage: {
      txt1: 'Log in',
      txt2: 'Phone number/email',
      txt3: '6-16 digit password',
      txt4: 'Sign Up',
      txt5: 'Forgot Your Password？',
      txt6: 'Message Login',
      txt7: 'WeChat Login',
      txt8: 'Sign Up',
      txt9: 'Graphical CAPTCHA',
      txt10: 'Enter the CAPTCHA',
      txt11: 'I have carefully read and agree to the above  agreements',
      txt12: 'User Agreement',
      txt13: 'Privacy Policy',
      txt14: 'Children User Agreement',
      txt15: 'Children Privacy Policy',
      txt16: 'and',
      txt17: 'Send code'
    }
  },
  common: {
    status: {
      txt1: 'Ongoing',
      txt2: 'Ended'
    },
    btns: {
      txt1: 'Confirm',
      txt2: 'Cancle',
      txt3: 'Back'
    }
  },
  Activity: {
    txt1: 'Plaza'
  },
  Discover: {
    discover: 'Discover'
  },
  NoAuthorityPage: {
    NoAuthority: 'You do not have access to the page',
    predecessors: 'The current mission can only be unlocked after completing the pre-task'
  },
  ApplySchool: {
    applySchool: 'Apply for a new school',
    yourName: 'Your name:',
    ContactInformation: 'Contact information:',
    yourSchool: 'Your school:',
    region: 'Administrative region:',
    remark: 'remark:',
    description: 'Description: The Organizing committee will contact you to help complete the registration after receiving the application.',
    submit: 'Submit',
    chooseArea: 'Select administrative area',
    chooseProvincial: 'Provincial and municipal selection',
    Cancel: 'Cancel',
    OK: 'OK',
    province: 'Province',
    city: 'City',
    success: 'Submitted successfully',
    SubmitFailure: 'Submit failure',
    copyLink: 'Prompt',
    copy: 'Copy',
    copyTitle: '复制'
  },
  user: {
    phone: 'Phone number/email',
    psd: '6-16 digit password',
    rpsd: 'Re-enter password',
    imgValicode: 'Graphical CAPTCHA',
    validateCode: 'Mobile Phone/Mail Verification Code',
    phoneOnly: 'Please Enter the Phone Number',
    emailOnly: 'Please Enter the Email',
    smsValidateCode: 'Enter the SMS code',
    graphCode: 'Graphical CAPTCHA',
    verifCode: 'Mobile Phone/Mail Verification Code',
    oldPassword: 'Please enter your old password',
    newPassword: 'Please enter a new password',
    rePassword: 'Re-enter new password',
    rePassword1: 'Please enter the password again',
    verificationCode: 'Graphical CAPTCHA',
    changePsd: 'Change password',
    changePnum: 'Replace the phone',
    changeEmail: 'Change email',
    tip1: 'Please enter a new phone number and verify it',
    tip2: 'Please enter a new email and verify it',
    tip3: 'For account security, please verify your current phone number first：',
    tip4: 'Please enter a new phone number and verify it',
    tip5: 'For account security, please verify your current email first：',
    tip6: 'Successfully replaced. The account does not exist. Please set the login password to complete the registration process',
    tip7: 'and',
    oldPwd: 'Old password',
    newPwd: 'New Password',
    rNewPwd: 'Confirm password',
    comfirm: 'Comfirm',
    cancel: 'Cancel',
    phone1: 'phone',
    email: 'Email',
    password: 'Password',
    Accounts: 'Accounts Setting',
    AccountBinding: 'Accounts Bindding',
    rightEmail: 'Please fill in the correct email format',
    rightPhone: 'Please fill in the correct format of your phone number',
    ReplacementSuccessful: 'Replacement Successful',
    bindNow: 'Bind now',
    verifTip: 'Send code',
    toReGet: 'sResend',
    SubmitFailure: 'Submit failure',
    copyLink: 'Prompt',
    copy: 'Copy',
    copyTitle: 'Copy'
  }
}
const en = {
  ...flowImageEN,
  ...message,
  ...flowAcademicReportEN,
  ...flowActiveEN,
  ...flowAdmissionTicketEN,
  ...flowCertificateEN,
  ...flowComplainEN,
  ...flowConsultEN,
  ...flowCouponEN,
  ...flowDiscoverEN,
  ...flowFollowUsEN,
  ...flowGradeReportEN,
  ...flowGroupEN,
  ...flowLoginEN,
  ...flowMessageEN,
  ...flowOrderEN,
  ...flowPayTheFeesEN,
  ...flowPersonalDataEN,
  ...flowReviewEN,
  ...flowSignUpEN,
  ...flowTaskEN,
  ...flowTeamUpEN,
  ...flowHomeEN
}
export default en



// WEBPACK FOOTER //
// ./src/assets/locale/en.js